<!-- Modal backdrop com z-index alto -->
<div 
  *ngIf="visivel" 
  class="modal-backdrop-custom"
  (click)="fecharSeClicarFora($event)"
>
  <div class="modal-dialog-custom">
    <div class="modal-content-custom">
      
      <!-- Modal Header -->
      <div class="modal-header-custom">
        <h4 class="modal-title-custom">
          <i class="fa fa-exclamation-triangle"></i>
          Atenção!
        </h4>
        <button 
          type="button" 
          class="close-button-custom" 
          (click)="fecharPopup()"
          aria-label="Close"
        >
          ×
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body-custom">
        <p class="subtitle-text">Verifique as inconsistências abaixo:</p>
        
        <!-- Inconsistências -->
        <div class="inconsistencias-container">
          <div class="inconsistencias-panel">
            <div class="inconsistencias-header">
              <h3 class="inconsistencias-title">Inconsistências</h3>
            </div>
            <div class="inconsistencias-content">
              <div class="inconsistencia-item" *ngFor="let mensagem of mensagensInconsistencia">
                {{ mensagem }}
              </div>
            </div>
          </div>
        </div>

        <!-- Avisos de ação -->
        <div class="warning-message">
          <i class="fa fa-warning"></i>
          Escolha <strong>Não</strong> caso queira permanecer na tela e resolver as inconsistências ou <strong>Sim</strong> caso queira prosseguir.
        </div>
        <div class="danger-message">
          <i class="fa fa-warning"></i>
          <strong>CASO PROSSIGA OS DADOS JÁ INFORMADOS SERÃO PERDIDOS!</strong>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn-nao"
          (click)="corrigirInconsistencias()"
        >
          Não
        </button>
        <button
          type="button"
          class="btn-sim"
          (click)="continuarNavegacao()"
        >
          Sim
        </button>
      </div>

    </div>
  </div>
</div>